import { createTheme } from "@mui/material/styles";
import colors from "./colors";

const theme = createTheme({
  palette: {
    primary: {
      main: colors.primary
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1440
    }
  },
  typography: {
    fontFamily: ["Open Sans", "sans-serif"].join(","),
  },
  components: {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white
        },
        expandIconWrapper: {
          color: colors.primary,
          "& svg": {
            fontSize: 16
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        outlined: {
          height: "32px",
          textTransform: "none",
          fontSize: 14,
          fontWeight: 500,
          border: `1px solid ${colors.blueColor1}`,
          backgroundColor: colors.lightGrey2
        },
        contained: {
          fontWeight: 500,
          textTransform: "none"
        },
        text: {
          fontWeight: 500,
          textTransform: "none"
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: "12px",
          paddingBottom: "12px"
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          paddingTop: "2px",
          paddingBottom: "3px",
          paddingLeft: "15px",
          "&.Mui-selected": {
            backgroundColor: colors.white,
            borderLeft: `3px solid ${colors.orangeColor1}`,
            paddingLeft: "12px",
            "& .MuiTypography-root": {
              fontWeight: 500,
              color: colors.black
            }
          }
        },
        divider: {
          borderBottom: "1px solid transparent"
        }
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "36px"
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          marginTop: "1px",
          marginBottom: "1px"
        },
        primary: {
          fontSize: 14,
          fontWeight: 400,
          color: colors.primary
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: 0
        }
      }
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          marginTop: 2,
          padding: "10px 25px",
          backgroundColor: colors.lightGrey1
        },
        separator: {
          fontSize: 14,
          marginLeft: "16px",
          marginRight: "16px",
          color: colors.lightGrey7
        }
      }
    }
  }
});

export default theme;
